<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>余额明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        商户ID：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.ApplicationUserId"
        ></el-input>
      </div>
      <div class="item">
        起止时间：
      </div>
      <div class="item">
        <el-date-picker
          type="date"
          placeholder="开始时间"
          size="small"
          v-model="form.StartTime"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <el-date-picker
          type="date"
          placeholder="结束时间"
          size="small"
          v-model="form.EndTime"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="item">
        类型：
      </div>
      <div class="item w1">
        <el-select
          placeholder="请选择"
          size="small"
          v-model="form.OverMoneyType"
        >
          <el-option :value="0" label="全部"> </el-option>
          <el-option :value="1" label="收入"> </el-option>
          <el-option :value="2" label="支出"> </el-option>
        </el-select>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <!-- <div class="tips">商户共计收入：<font color="#ff0000">15</font>元, 共计支出：<font color="#ff0000">14</font>元</div> -->
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%;margin-top: 15px;"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column property="applicationUserId" label="商户" align="center">
      </el-table-column>
      <el-table-column property="overMoneyType" label="类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.overMoneyType == 0">全部</span>
          <span v-if="scope.row.overMoneyType == 1">自动</span>
          <span v-if="scope.row.overMoneyType == 2">手工</span>
        </template>
      </el-table-column>
      <el-table-column property="changeAmount" label="变动金额" align="center">
      </el-table-column>
      <el-table-column property="overMoney" label="账户余额" align="center">
      </el-table-column>
      <el-table-column property="modifiedTime" label="时间" align="center">
      </el-table-column>
      <el-table-column property="remarks" label="备注" align="center">
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      tableData: [],
      form: {
        Id: '',
        ApplicationUserId: '',
        OverMoneyType: 0,
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    async getLists() {
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      let header = await mgr();
      api
        .get('/api/Paid/GetBalancesDetailsList', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      console.log(this.form);
      this.getLists();
    },
    changePage(page) {
      console.log(page);
      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.form = {
        Id: '',
        ApplicationUserId: '',
        OverMoneyType: '',
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      };
      this.tableData = [];
      this.getLists();
    }
  }
};
</script>

<style scoped>
.gs_container {
  background-color: #fff;
}

.search-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.search-box .item {
  margin-right: 10px;
}

.search-box .item.w1 {
  width: 120px;
}

.tips {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.pagination {
  text-align: center;
  margin: 20px 0;
}
</style>
